module.exports = __webpack_public_path__ + "static/media/YM90_4.04549720.jpg";